// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.card-image {
  max-width: 100%;
  height: auto;
  width: 250px;
}

.card-title {
  color: #000000;
  font-size: 22px;
  line-height: 24px;
  font-weight: 700;
  margin: 15px 0 0 0;
}

.card-subtitle {
  color: #666666;
  font-size: 17px;
  line-height: 1.5rem;
}

.card-title.dark-mode,
.card-subtitle.dark-mode {
  background-color: transparent;
}

.project-card {
  display: flex;
  flex-direction: column;
  background-color: rgb(255, 255, 255);
  padding: 1.5rem;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
  justify-content: flex-start;
}

.project-card-light {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  transition: all 0.3s ease;
}

.project-card-dark {
  background-color: #12121a;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0px 10px 30px -15px #d9dbdf;
  transition: all 0.25s ease;
}

.project-detail {
  text-align: center;
}

.project-card-light:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;
}

.project-card-dark:hover {
  box-shadow: 0px 20px 30px -10px #d9dbdf;
}

.project-image {
  position: relative;
  height: 160px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.project-image .card-image {
  max-height: 140px;
  width: auto;
  object-fit: contain;
}

.projects-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 1rem 1rem;
  gap: 1rem 1rem;
  align-items: stretch;
}

.project-card .project-detail {
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.project-card .project-card-footer {
  margin-top: auto;
  padding-top: 1rem;
}

.project-card-footer span.project-tag {
  background: #55198b;
  color: #f5f2f4;
  vertical-align: middle;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  white-space: nowrap;
  line-height: 1.5;
  margin: 0 0.5rem 0.5rem 0;
  padding: 0 0.75em;
  cursor: pointer;
  transition: 0.2s ease-in;
}

@media (max-width: 768px) {
  .project-subtitle {
    font-size: 16px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/StartupProjects/StartupProjects.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,eAAA;EACA,YAAA;EACA,YAAA;AAEF;;AAAA;EACE,cDEW;ECDX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AADA;EACE,cDFa;ECGb,eAAA;EACA,mBAAA;AAIF;;AAAA;;EAEE,6BAAA;AAGF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,oCDMiB;ECLjB,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,2BAAA;AAIF;;AAFA;EACE,kDAAA;EAGA,yBAAA;AAKF;;AAFA;EACE,yBAAA;EACA,2CAAA;EACA,uCAAA;EAGA,0BAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAHA;EACE,kDAAA;AAMF;;AAJA;EACE,uCAAA;AAOF;;AALA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAQF;;AALA;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AAQF;;AALA;EACE,aAAA;EACA,2DAAA;EACA,mBAAA;EAAA,cAAA;EACA,oBAAA;AAQF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAMF;;AAJA;EACE,gBAAA;EACA,iBAAA;AAOF;;AAJA;EACE,mBDzFY;EC0FZ,cD5DiB;EC6DjB,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AAOF;;AAJA;EACE;IACE,eAAA;IACA,kBAAA;EAOF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.card-image {\n  max-width: 100%;\n  height: auto;\n  width: 250px;\n}\n.card-title {\n  color: $titleColor;\n  font-size: 22px;\n  line-height: 24px;\n  font-weight: 700;\n  margin: 15px 0 0 0;\n}\n.card-subtitle {\n  color: $cardSubtitle;\n  font-size: 17px;\n  line-height: 1.5rem;\n}\n\n// Defeat the global .dark-mode background that bleeds onto card text elements.\n.card-title.dark-mode,\n.card-subtitle.dark-mode {\n  background-color: transparent;\n}\n.project-card {\n  display: flex;\n  flex-direction: column;\n  background-color: $lightBackground2;\n  padding: 1.5rem;\n  border-radius: 10px;\n  border: 1px solid $lightBorder1;\n  justify-content: flex-start;\n}\n.project-card-light {\n  box-shadow: $lightBoxShadowDark 0px 10px 30px -15px;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.project-card-dark {\n  background-color: #12121a;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0px 10px 30px -15px $darkBoxShadow;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.25s ease;\n}\n\n.project-detail {\n  text-align: center;\n}\n.project-card-light:hover {\n  box-shadow: $lightBoxShadowDark 0px 20px 30px -10px;\n}\n.project-card-dark:hover {\n  box-shadow: 0px 20px 30px -10px $darkBoxShadow;\n}\n.project-image {\n  position: relative;\n  height: 160px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.project-image .card-image {\n  max-height: 140px;\n  width: auto;\n  object-fit: contain;\n}\n\n.projects-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem 1rem;\n  align-items: stretch; // all cards in a row match the tallest card's height\n}\n\n// Push the footer (action buttons) to the bottom of each card so that equal-height\n// cards still look tidy regardless of how short their description is.\n.project-card .project-detail {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.project-card .project-card-footer {\n  margin-top: auto;\n  padding-top: 1rem;\n}\n\n.project-card-footer span.project-tag {\n  background: $buttonColor;\n  color: $lightBackground3;\n  vertical-align: middle;\n  align-items: center;\n  border-radius: 4px;\n  display: inline-flex;\n  font-size: 0.75rem;\n  height: 2em;\n  justify-content: center;\n  white-space: nowrap;\n  line-height: 1.5;\n  margin: 0 0.5rem 0.5rem 0;\n  padding: 0 0.75em;\n  cursor: pointer;\n  transition: 0.2s ease-in;\n}\n\n@media (max-width: 768px) {\n  .project-subtitle {\n    font-size: 16px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
